import Vue from 'vue'
import app from './app'
import router from './router'
import "./common/stylus/index.styl"
import "../static/css/reset.css"
import 'element-ui/lib/theme-default/index.css'

Vue.config.productionTip = false

// element
import {
  Carousel,
  Scrollbar,
  CarouselItem,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Button,
  Message,

  // 未使用
  /*
   Pagination,
   Table,
   TableColumn,

   Icon,

   Menu,
   RadioGroup,
   RadioButton,
   Submenu,
   Input,
   MenuItem,
   Checkbox,
   CheckboxGroup,
   DatePicker,
   Breadcrumb,
   BreadcrumbItem,
   MessageBox,
   Tabs,
   TabPane,
   Dialog,
   Form,
   FormItem,
   Option,
   OptionGroup,
   Select,
   Dropdown,
   DropdownMenu,
   DropdownItem,
   Tag,
   Tree,
   Radio,
   Upload,

   TimeSelect,
   TimePicker,
   Popover,
   Tooltip,
   Alert,
   Slider,
   Autocomplete,
   MenuItemGroup,
   InputNumber,
   Switch,
   ButtonGroup,


   Progress,
   Spinner,
   Badge,
   Card,
   Rate,
   Steps,
   Step,


   Cascader,
   ColorPicker,
   Loading,

   Notification*/
} from 'element-ui'
//已用
Vue.use(Carousel)
Vue.use(Scrollbar)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Button)

//未用
/*
 Vue.use(Autocomplete)
 Vue.use(MenuItemGroup)
 Vue.use(InputNumber)
 Vue.use(Switch)
 Vue.use(ButtonGroup)
 Vue.use(Loading.directive)
 Vue.use(Pagination)
 Vue.use(Table)
 Vue.use(TableColumn)
 Vue.use(Icon)
Vue.use(Tabs)
Vue.use(TabPane)
 Vue.use(Menu)
 Vue.use(RadioGroup)
 Vue.use(RadioButton)
 Vue.use(Submenu)
 Vue.use(Input)
 Vue.use(MenuItem)
 Vue.use(Checkbox)
 Vue.use(CheckboxGroup)
 Vue.use(DatePicker)
 Vue.use(Breadcrumb)
 Vue.use(BreadcrumbItem)
 Vue.use(Dialog)
 Vue.use(Form)
 Vue.use(FormItem)
 Vue.use(Option)
 Vue.use(OptionGroup)
 Vue.use(Select)
 Vue.use(Dropdown)
 Vue.use(DropdownMenu)
 Vue.use(DropdownItem)
 Vue.use(Tag)
 Vue.use(Tree)
 Vue.use(Radio)
 Vue.use(Upload)

 Vue.use(TimeSelect)
 Vue.use(TimePicker)
 Vue.use(Popover)
 Vue.use(Tooltip)
 Vue.use(Alert)
 Vue.use(Slider)

 Vue.prototype.$msgbox = MessageBox
 Vue.prototype.$confirm = MessageBox.confirm
 Vue.prototype.$prompt = MessageBox.prompt
 Vue.prototype.$alert = MessageBox.alert

 Vue.prototype.$loading = Loading.service
 Vue.prototype.$notify = Notification

*/

Vue.prototype.$message = Message


new Vue({
  el: '#app',
  render: h => h(app),
  router
})



// WEBPACK FOOTER //
// ./src/main.js